/**
 * TPIN entry rules — presentation only (UX-RW-03 S-DIR). Server validation is
 * contract-owned (ADR-005 §3.1: `q` is `^[0-9]+$`, length 1..32); these helpers
 * only stop the field accepting what the server would refuse, and never decide
 * which TPINs exist or how they are ordered.
 */

/** ADR-005 §3.1: a TPIN prefix is at most 32 characters. */
export const MAX_TPIN_LENGTH = 32

/** Search-as-you-type returns at most this many suggestions (PD-43, CRM-012). */
export const SUGGESTION_LIMIT = 50

/** Keep digits only, capped at the contract length. */
export function normalizeTpinInput(raw: string): string {
  return raw.replace(/[^0-9]/g, '').slice(0, MAX_TPIN_LENGTH)
}

/**
 * Move a list highlight by `delta` and keep it inside the list. An empty list
 * always answers 0, so a highlight is never negative.
 */
export function moveHighlight(current: number, delta: number, length: number): number {
  if (length === 0) return 0
  return Math.min(Math.max(current + delta, 0), length - 1)
}

/**
 * Split a TPIN into the typed prefix and the rest, for emphasis. The match is
 * on the ORIGINAL string (PD-24); a TPIN that does not start with the query
 * gets no emphasis rather than a wrong one.
 */
export function splitPrefix(tin: string, query: string): { readonly prefix: string; readonly rest: string } {
  const prefix = tin.startsWith(query) ? query : ''
  return { prefix, rest: tin.slice(prefix.length) }
}
